import {FC, Badge, useMemo, Link} from 'external/react'
import type { SubscriptionStatus } from 'types/context/package'

type SubscriptionStatusProps = {
	status: SubscriptionStatus
	subscription: string
}

const statusHandlers = {
	active: ['success', 'Activo'],
	canceled: ['dark', 'Cancelado'],
	expired: ['dark', 'Expirada'],
    pending: ['success', 'Pendiente'],
	past_due: ['danger', 'Inactivo']
}

const SubscriptionStatusBadge: FC<SubscriptionStatusProps> = props => {
	const {status, subscription} = props
	const badge = useMemo(() => {
		const [bg, label] = statusHandlers[status]
		return status === 'past_due'
			? <Badge pill bg={bg} as={Link} style={{fontSize: '13px', cursor:'pointer'}} to={`/home/payment/history?subscription=${subscription}`} title = 'Tienes una deuda pendiente. Haz click aqui!'>{label}</Badge>
			: <Badge pill bg={bg} style={{fontSize: '13px', cursor: 'default'}}>{label}</Badge>
	}, [status, subscription])
	return <>{badge}</>
}

export default SubscriptionStatusBadge;
